/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isFunction } from 'lodash';

// Components
import CounterStat from 'content-hub/components/cards/CounterStat.vue';
import VideoList from 'shared/ui/components/media/VideoList.vue';

const __vue_script__ = {
    name: 'VideoLibrary',

    components: { CounterStat, VideoList },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            ready: false,
            stats: {
                available_videos: 0
            },
            total: 0,
            videos: [],
            unsubscribeListener: null,
            unsubscribeStore: null
        };
    },

    mounted() {
        this.unsubscribeStore = this.$store.subscribe(({ type, payload }) => {
            if (
                type === 'SET_IS_UPLOADING' && payload === false ||
                type === 'LAST_UPLOADED_AT' && payload !== 0
            ) {
                this.loadContent();
            }
        });
    },

    async created() {
        this.loadContent();

        this.unsubscribeListener = await this.$services.signal.addSignalListener(
            'document/content-video/update',
            signal => this.onVideoUpdate(signal)
        );
    },

    beforeDestroy() {
        if (isFunction(this.unsubscribeListener)) {
            this.unsubscribeListener();
        }

        if (isFunction(this.unsubscribeStore)) {
            this.unsubscribeStore();
        }
    },

    methods: {

        /**
         * Loads the video contents
         *
         * @param {number} [page=1] the page to load
         */
        async loadContent(page = 1) {
            try {
                const eventId = this.params.event._id;
                const { total, items } = await this.$services.content.loadPaginatedContents(eventId, { pageNumber: page });

                items.forEach((content) => {
                    content.thumbnailSrc = this.$services.content.getContentThumbnailOrDefaultUrl(eventId, content);
                });

                this.total = total || 0;
                this.videos = items;
                this.ready = true;

            } catch (error) {
                console.error('[VideoLibrary] Could not load video list due to an error:', error.message);
            }
        },

        /**
         * Updates listing when a modification is made to the video document
         *
         * @param {object} signal
         */
        onVideoUpdate(signal) {
            const videoId = signal.targetId;
            const index = this.videos.findIndex(v => v.id === videoId);

            if (index < 0) {
                return;
            }

            const doc = {
                ...this.videos[index],
                ...signal.document
            };

            this.$set(this.videos, index, doc);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-library"},[_c('h1',[_vm._v(_vm._s(_vm.$t('blueprint.modules.video_library')))]),_c('section',{staticClass:"stats"},[_c('counter-stat',{attrs:{"icon":"ic-video","count":_vm.total,"label":"video_library.stats.total_videos"}})],1),(_vm.ready)?_c('video-list',{attrs:{"event":_vm.params.event,"total-videos":_vm.total,"videos":_vm.videos},on:{"page-changed":_vm.loadContent}}):_vm._e()],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "VideoLibrary.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__